import { externalApiAxios } from '/@/modules/core/app/helpers/AxiosHelper';

export class BaseExternalResource {
  /**
   * @param route
   * @param data
   * @returns {*}
   */
  async postData(route, data) {
    return externalApiAxios.post(route, data);
  }

  /**
   * @param route
   * @returns {*}
   */
  async getData(route) {
    return externalApiAxios.get(route);
  }
}
